/**
 * meetingManage模块接口列表
 */
import axios from './utils/https' // 导入http中创建的axios实例

const meetingManage = {
  // 获取会议列表
  getMeetingList (params) {
    return axios.post('/api/meetingManage/getMeetingList', params)
  },
  // 删除会议
  deleteMeeting (params) {
    return axios.delete('/api/meetingManage/deleteMeeting', { params: params })
  },
  // 会议发布
  meetingPublish (id) {
    return axios.post('/api/meetingManage/meetingPublish', '=' + id)
  },
  // 会议取消发布/结束会议
  meetingCloseRelease (id) {
    return axios.post('/api/meetingManage/meetingCloseRelease', '=' + id)
  },
  // 关闭会议
  meetingClose (id) {
    return axios.post('/api/meetingManage/meetingClose', '=' + id)
  },
  // 创建会议
  addMeeting (params) {
    return axios.post('/api/meetingManage/addMeeting', params)
  },
  // 根据会议ID获取投票会议信息
  getMeetingVoteInfo (params) {
    return axios.get('/api/meetingManage/getMeetingVoteInfo', { params })
  },
  // 生成二维码图片
  makeCode (id) {
    return axios.post('/api/meetingManage/makeCode', '=' + id)
  },
  // 根据会议ID获取投票会议信息
  getMeetingVote (params) {
    return axios.get('/api/meetingManage/getMeetingVote', { params })
  },
  // 编辑会议
  editMeeting (params) {
    return axios.post('/api/meetingManage/editMeeting', params)
  },
  // 获取会议基本信息
  getMeetingInfo (params) {
    return axios.get('/api/meetingManage/GetMeetingInfo', { params })
  },
  getMenuList (params) {
    return axios.get('/api/meetingManage/GetMenuList', { params })
  }
}

export default meetingManage
